(() => {
  angular
    .module('app.components')
    .directive('reportLoader', ReportLoader);

  ReportLoader.$inject = ['$timeout'];

  function ReportLoader($timeout) {
    const assets = [{
      gif: 'bus',
      text: 'Hang loose, updated numbers should arrive any minute!'
    }, {
      gif: 'mixer',
      text: 'Hang tight, we’re stirring up some updated numbers!'
    }, {
      gif: 'calculator',
      text: 'Hang tight, updated numbers should be crunched any minute!'
    }];
    const assetIndex = Math.floor(Math.random() * 3);
    const asset = assets[assetIndex > 2 ? 2 : assetIndex];

    return {
      replace: true,
      scope: {
        time: '@',
        from: '@',
        type: '@',
        status: '@',
        sourceYoutube: '@',
        sourceFacebook: '@',
        sourceAudiencereport: '@',
      },
      link: (scope, element, attrs) => {
        scope.gif = asset.gif;
        scope.text = asset.text;
        scope.isStandard = attrs.type === 'standard';
        scope.isStatusActive = attrs.status !== 'new' && attrs.status !== 'dirty';

        const hasStatus = status => ([
          attrs.sourceYoutube,
          attrs.sourceFacebook,
          attrs.sourceAudiencereport,
        ].some(item => item === status));

        const updateStatus = () => {
          scope.hasError = hasStatus('error');
          scope.hasPending = hasStatus('pending');
        };

        attrs.$observe('sourceYoutube', sourceYoutube => {
          updateStatus();
        });
        attrs.$observe('sourceFacebook', sourceFacebook => {
          updateStatus();
        });
        attrs.$observe('sourceAudiencereport', sourceAudiencereport => {
          updateStatus();
        });

        attrs.$observe('time', time => {
          $timeout(() => {
            element.removeClass('reset');
          }, 100);
        });
      },
      template: `
        <div class="page-loader reset">
          <div ng-include="'../../assets/js/app/components/reportLoader.icon.template.html?v=${window.BUILD_VERSION}'"></div>
          <div class="page-loader-bar-keeper"
            ng-if="type === 'standard'">
            <div class="page-loader-bar"
              style="left:{{from || 0}}%; width:{{100 - (from || 0)}}%; transition-duration:{{time || 0}}s"></div>
          </div>
          <div class="page-loader-text">
            <div ng-include="'../../assets/js/app/components/reportLoader.message.template.html?v=${window.BUILD_VERSION}'"></div>
          </div>

          <div ng-include="'../../assets/js/app/components/reportLoader.integrations.template.html?v=${window.BUILD_VERSION}'"></div>
        </div>`,
    };
  }
})();
